import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgKeSharedRoutingModule } from './sg-ke-shared-routing.module';
import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';


@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    SgKeSharedRoutingModule,
    SgBaseSharedModule
  ],
  exports: [
  ],
  providers: [
  ]
})
export class SgKeSharedModule { }
